<template>
  <div class="peoplechoice">
    <Header :title="$t('m.ConferenceRoomSelection')"></Header>
    <div class="serch bgc3">
      <span>{{$t('m.ConferenceTerminal')}}</span>
      <span style="float:right">
                <span class="serchbox">
                    <Icon type="ios-search"></Icon>
                    <input @input="search" class="searchinput" :placeholder="$t('m.PlsenterTerminalName')" type="text"
                           v-model="searchcontent">
                </span>
                <span>{{$t('m.Search')}}</span>
            </span>
    </div>
    <div class="choice">{{$t('m.Selectedcolon')}}{{choice}}</div>
    <div class="main">
      <CheckboxGroup v-model="social">
        <div class="mainitem">
          <div :key='index' class="content" v-for="(item,index) in terminallists">
            <div class="contentitem">
            <span>
                <Checkbox :label="item.id">
                    <span style="width:2.5rem;display:inline-block;margin-left:0.1rem;">
                      <Icon type="laptop"></Icon>{{item.name}}</span>
                </Checkbox>
                <span>
                    <img
                      :src="item.occupied=='true'?imgpath.control_warning:imgpath.control_blank"
                      alt
                      style="width:0.2rem"/>
                </span>
            </span>
            </div>
          </div>
        </div>
      </CheckboxGroup>
    </div>
    <div @click="goback" class="bottom bgc">
      {{$t('m.OKBtn')}}
    </div>
  </div>
</template>
<script>
  import Header from '../header/header'
  import {terminalList,findterminallistAndStatus} from "../../assets/js/url";

  export default {
    name: "peoplechoice",
    data() {
      return {
        social: [],
        socialmap: null,
        terminallists: [],
        searchcontent: null
      }
    },
    components: {
      Header
    },
    activated() {
      this.social = [];
      this.getterminiallist();
      this.initmessage()
    },
    methods: {
      search() {
        if (this.searchcontent) {
          $(".contentitem").css("display", "none");
          $(
            ".contentitem:contains(" + this.searchcontent.toUpperCase() + ")"
          ).css("display", "block");
        } else {
          $(".contentitem").css("display", "block");
        }
      },
      goback() {
        const data = this.$route.params
        if (data.fromrouter) {
          this.$router.push(data.fromrouter);
          return
        }
        this.$router.push("/attendmeeting");
      },
      getterminiallist() {
        if(this.$route.params.meetingType=="1"){
            console.log("及时会议")
              this.$http
              .post(findterminallistAndStatus, {
                useruuid: window.sessionStorage.getItem("UUID"),
                pagesize: 10000,
                start: 0,
                departmentName: '',
                departmentId: "",
                time:''
              })
              .then(res => {
                  if (res.data.status == 2000) {
                     this.terminallists = res.data.data;
                     console.log(res)
                    const map = new Map();
                    res.data.data.forEach(element => {
                      map.set(element.id + '', element.name);
                    });
                    this.socialmap = map;
                  } else {
                    this.$toast(this.$t('m.TerminalListGetFail'));
                  }
                },
                err => {
                  this.$toast(this.$t('m.TerminalListGetFail'));
                });
        }else{
            this.$http
              .post(findterminallistAndStatus, {
                useruuid: window.sessionStorage.getItem("UUID"),
                pagesize: 10000,
                start: 0,
                departmentName: '',
                departmentId:"",
                time:this.$route.params.datavalue+" " +this.$route.params.timevalue+":00"
              })
              .then(res => {
                  if (res.data.status == 2000) {
                     this.terminallists = res.data.data;
                    const map = new Map();
                    res.data.data.forEach(element => {
                      map.set(element.id + '', element.name);
                    });
                    this.socialmap = map;
                  } else {
                    this.$toast(this.$t('m.TerminalListGetFail'));
                  }
                },
                err => {
                  this.$toast(this.$t('m.TerminalListGetFail'));
                });
        }
        // this.$http.post(terminalList, {
        //   useruuid: window.sessionStorage.getItem('UUID'),
        //   pagesize: 10000,
        //   start: 0,
        //   departmentName: this.searchcontent,
        //   departmentId: 0
        // }).then(
        //   res => {
        //     if (res.data.status == 2000) {
        //       this.terminallists = res.data.data;
        //       const map = new Map()
        //       res.data.data.forEach(element => {
        //         map.set(element.id+'', element.info.name)
        //       });
        //       this.socialmap = map
        //     } else {
        //       this.$toast("终端列表获取失败,请重试")
        //     }
        //   },
        //   err => {
        //     this.$toast("终端列表获取失败,请重试")
        //   }
        // )
      },
      initmessage() {
        const data = this.$route.params
        if (data.message) {
          this.social = data.message.split(",")
        }
      },
    },
    computed: {
       imgpath() {
        return this.$store.state.imagestyle[this.$store.state.cssstyle]
      },
      choice() {
        if (this.socialmap instanceof Map) {
          const _this = this
          const data = this.$store.state.meeting.cfterminal
          .split(',')
          .map(function (item, index) {
            item = item + '';
            if (_this.socialmap.has(item)) {
              return _this.socialmap.get(item)
            }
          }).join(',')
          this.$store.commit("setmeetingcfterminalname", data);
          return data
        } else {
          return ''
        }
      }
    },
    watch: {
      social(data) {
         console.log(data)
        if (data == "") {
          this.$store.commit("setmeetingcfterminal", '');
          return
        }
        this.$store.commit("setmeetingcfterminal", data.join(","))
      }
    }
  }
</script>
<style scoped>
  .peoplechoice {
    width: 100%;
  }

  .serch {
    height: 0.52rem;
    line-height: 0.52rem;
    padding: 0 0.15rem;
    font-size: 0.15rem;
    width: 100%;
    position: fixed;
    top: 0.44rem;
    left: 0;
    background-color: #fff;
    z-index: 100;
    border-bottom: 1px solid #ddd;
  }

  .choice {
    width: 3.5rem;
    padding: 0.15rem 0.45rem 0.05rem 0.15rem;
    line-height: 0.30rem;
    padding-top: 0.50rem;
    word-wrap: break-word;
  }

  .serchbox {
    width: 1.8rem;
    height: 0.32rem;
    line-height: 0.32rem;
    display: inline-block;
    margin-top: 0.1rem;
    border-radius: 5px;
    border: 1px solid #ddd;
    float: left;
    margin-right: 0.1rem;
    box-sizing: border-box;
    padding: 0 0.1rem;
  }

  .searchinput {
    width: 1.2rem;
    height: 0.32rem;
    border: none;
    background-color: transparent;
    outline: none;
    line-height: 0.32rem;
  }

  i {
    font-size: 0.2rem;
    vertical-align: middle;
    margin-right: 0.1rem;
  }

  .title {
    padding: 0 0.15rem;
    height: 0.28rem;
    background-color: #F8F8F8;
    line-height: 0.28rem;
    font-size: 0.16rem;
    font-weight: bold;
  }

  .main {
    padding: 0 0 0.5rem;
  }

  .content {
    padding: 0.1rem 0.15rem;
    line-height: 0.2rem;
  }

  .bottom {
    width: 100%;
    height: 0.49rem;
    line-height: 0.49rem;
    color: #fff;
    font-size: 0.18rem;
    text-align: center;
    position: fixed;
    bottom: 0px;
    left: 0px;
  }

  .right {
    position: fixed;
    bottom: 0.49rem;
    right: 0px;
    width: 0.38rem;
    background-color: #fff;
    padding: 0.1rem 0;
  }

  .right span {
    width: 100%;
    line-height: 0.16rem;
    display: inline-block;
    text-align: center;
  }
</style>




// WEBPACK FOOTER //
// src/components/content/roomchoice.vue